import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Crescent = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="60" viewBox="0 0 60 84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M59.5593 80.018C39.5558 78.7709 23.7178 62.1562 23.7178 41.8388C23.7178 21.5213 39.5558 4.90564 59.5593 3.6586C54.3715 1.34884 48.6278 0.0624447 42.5827 0.0624447C19.511 0.0624447 0.80735 18.7661 0.80735 41.8378C0.80735 64.9095 19.511 83.6132 42.5827 83.6132C48.6278 83.6132 54.3715 82.3287 59.5593 80.018Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
